module.exports = __webpack_public_path__ + "img/TW.038f8562.svg";